module.exports = __webpack_public_path__ + "pt.svg?24449c1ec1caed45579accf625635f61";